<template>
    <div class="news-detail-container">
        <div class="news-content">
            <div class="header" v-html="data?.title || ''"></div>
            <div class="creator-publish-time">
                <p class="creator-name">{{`发布人：${data.creatorName || '-'}`}}</p>
                <p>{{`发布时间：${data?.publishTime ? dayjs(data.publishTime).format('YYYY.MM.DD HH:mm:ss') : '-'}`}}</p>
            </div>
            <div class="content">
                <EditorView
                    :content="data.content"
                    :file-list="data.form2ResourceList"/>
                <!-- <FileView
                    v-if="data.contentForm === 3"
                    :file-data="curFile"/> -->
            </div>
        </div>
    </div>
</template>

<script setup>
import EditorView from './part/editor-view.vue';
import FileView from './part/file-view.vue';
import { reactive, onMounted, computed } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import dayjs from 'dayjs';

const store = useStore();

const route = useRoute();

let data = reactive({
    title: '', // 标题名称
    content: '', // 手动编辑内容
    publishTime: '', // 发布时间
    form2ResourceList: []
});

const curFile = computed(() => {
    return data?.form3Resource?.[0] || {};
})

// 全部备案信息
const brand = computed(() => {
    return store.state.brand || {};
})

const brandKey = computed(() => {
    return brand.value?.publishBrand?.brand || '';
})

const getStrainNoticeDetailFn = () => {
    if (!route.query.id) {
        return false;
    }
    G_transmit('getStrainNoticeDetail', {
        name: 'getStrainNoticeDetail',
        queries: {
            id: route.query.id
        }
    }).then(res => {
        // console.log(res);
        let result = res.data || {};
        Object.assign(data, result);
    });
}

// 判断是否是新闻栏目
const isInformation = computed(() => {
   return route.name === 'information';
})

onMounted(() => {
    debugger;
    store.dispatch('setBreadCrumb', [
        {
            name: isInformation.value ? (brandKey.value === 'desjyj' ? '教科研动态' : '新闻') : '公告'
        }
    ]);
    getStrainNoticeDetailFn();
})

</script>

<style lang='scss' scoped>
.news-detail-container {
    width: 100%;
    .breadcrumb {
        font-size: 14px;
        margin-bottom: 23px;
        .link {
            color: var(--srt-breadcrumb-text-color);
            &:hover {
                color: var(--srt-breadcrumb-hover-text-color);
            }
        }
        .separator {
            margin: 0 6px;
            color: var(--srt-color-gray);
        }
        .text {
            color: var(--srt-breadcrumb-disabled-text-color);
        }
    }
    .news-content {
        background: var(--srt-color-white);
        border-radius: 4px;
        padding: 50px;
        .header {
            font-size: 28px;
            color: var(--srt-main-text-color);
            line-height: 37px;
            white-space: pre-wrap;
        }
        .creator-publish-time {
            display: flex;
            font-size: 14px;
            color: var(--srt-color-gray);
            margin: 10px 0 30px 0;
            .creator-name {
                margin-right: 20px;
            }
        }
        .content {
            border-top: 1px solid #E0E2E4;
            padding-top: 30px;
        }
    }
}

</style>